import { ContactSupportButton } from './components/button/ContactSupportButton';
import { createErrorBoundary } from './components/error/CreateErrorBoundary';

export const AppErrorBoundary = createErrorBoundary({
  name: 'AppErrorBoundary',
  logMessage: 'Unhandled app render error',
  titleKey: 'somethingWentWrong',
  bodyKey: 'appErrorBody',
  secondaryAction: <ContactSupportButton />,
});
